const Colors = [
  {
    name: 'Light Pink',
    code: '#FFD1DC',
    previewClass: 'bg-pink-200'
  },
  {
    name: 'Light Sky',
    code: '#B0E2FF',
    previewClass: 'bg-sky-200'
  },
  {
    name: 'Light Lime',
    code: '#C8E6C9',
    previewClass: 'bg-lime-200'
  },
  {
    name: 'Light Yellow',
    code: '#FFF9C4',
    previewClass: 'bg-yellow-200'
  },
  {
    name: 'Light Violet',
    code: '#C5CAE9',
    previewClass: 'bg-violet-300'
  },
  {
    name: 'Light Purple',
    code: '#E1BEE7',
    previewClass: 'bg-pink-300'
  }
];

export default Colors;
